
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import SupportPage from '../pages/support/page';
import AdminLoginPage from '../pages/admin/login/page';
import AdminDashboardPage from '../pages/admin/dashboard/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/admin',
    element: <AdminLoginPage />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
